import { CustomTooltipProps } from "ag-grid-react";
import { ApartmentOwner, User } from "@/models/responses";

export const visibleOwnersTooltipComponent: (
    params: CustomTooltipProps<User, string>,
    ownerIdMap: Map<number, ApartmentOwner>,
) => string = (params, ownerIdMap) => {
    if (params.data?.isAdmin) {
        return "All Owners";
    }

    return (
        params.data?.visibleOwners
            .map((owner) => {
                return ownerIdMap.get(owner)?.fullName;
            })
            .join(",\n\n\t ") ?? ""
    );
};
